import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import type { RootState } from '../stores/rootReducer';
import type { AppDispatch } from '../stores/rootStore';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
